import React from "react";
import flex from "../assets/images/sidom/fotos/FlechaenCirc3.png";
import flex2 from "../assets/images/sidom/fotos/FlechaenCirc1.png";

export default function FeatureCard({ title, description }) {
  return (
    <div className=" h-[350px]   rounded-3xl border border-sidom-orange shadow-md bg-sidom-orange  dark:bg-sidom-blue overflow-hidden  flex flex-col  justify-center gap-4">
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <div className=" flex flex-col  justify-start items-start h-[20%] gap-1  w-full">
          <img src={flex2} alt="Logo " className="hidden dark:block w-7" />
          <img src={flex} alt="Logo " className="block dark:hidden w-7" />
          <div>
            <h1 className="text-2xl  font-bold text-sidom-light  ">{title}</h1>
          </div>
        </div>
        <div className="flex-1  h-[300px] mt-4 text-left sm:text-lg md:text-base lg:text-sm flex items-start justify-start  w-full">
          <p className="text-sidom-light dark:text-sidom-light mb-4">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
